import React, { useCallback, useEffect, useState } from 'react';

const idNameMapper = (item) => {
   const {
      id,
      name,
   } = item;

   return (
      <div
         key={ `list-item-${ name }-${ id }` }
      >
         {
            `${ id } - ${ name }`
         }
      </div>
   );
};

const nameMapper = (item) => {
   if (item?.name) {
      const {
         name,
      } = item;

      return (
         <div
            key={ `list-item-${ name }` }
         >
            { name }
         </div>
      );
   } else {
      return null;
   }
};

// Assumes each item in the list are objects with {id, name} properties
const ExpandableList = ({
   itemList = [],
   minItems = 2, // min number of elements/row displayed when not expanded,
   mapper = nameMapper,
}) => {
   const [isExpanded, setIsExpanded] = useState(false);
   const [isExpandable, setIsExpandable] = useState();

   useEffect(() => {
      setIsExpandable(itemList?.length > minItems);
   }, [minItems, itemList]);

   const getToggleExpandButton = useCallback(() => {
      if (isExpandable) {
         return (
            <div
               style={ {
                  color: '#3a9bdc',
               } }
               className='cursor-pointer'
               onClick={ () => {
                  setIsExpanded(((prevState) => !prevState));
               } }
            >
               { isExpanded ? `less` : `(...)` }
            </div>
         );
      }
   }, [isExpandable, isExpanded]);

   const getListItem = useCallback(() => {
      const minPossibleItemList = Math.min(minItems, itemList.length);
      const numItemsToDisplay = isExpanded ? itemList.length : minPossibleItemList;
      const componentList = itemList.slice(0, numItemsToDisplay)
         .map(mapper);

      return componentList;
   }, [isExpanded, minItems, itemList]);

   return (
      <div>
         { getListItem() }
         { getToggleExpandButton() }
      </div>
   );
};

export {
   nameMapper,
   idNameMapper,
};

export default ExpandableList;
